import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';

interface ConfirmationTableDialogProps {
  id: number;
  message?: string;
  handleOnClose?: () => void;
  handleDelete?: (id: number) => void;
}

export default function ConfirmationDeleteTableDialog(params: ConfirmationTableDialogProps) {
  const { id, message, handleOnClose, handleDelete } = params;
  const { t } = useTranslation();

  const [openDialog, setOpenDialog] = useState(false);

  /**
   * Opens the confirmation dialog for deleting a row.
   *
   * @param {number} id - The ID of the row to be deleted.
   */
  const handleOpenDialog = () => {
    // Set the selected row ID and open the dialog.
    setOpenDialog(true);
  };

  /**
   * Closes the confirmation dialog.
   */
  const handleCloseDialog = () => {
    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  const handleConfirmDelete = () => {
    handleDelete(id);
    // Close the dialog and reset the selected row ID.
    setOpenDialog(false);
  };

  return (
    <>
      <GridActionsCellItem
        key={990}
        label={t('actions.delete')}
        icon={<DeleteIcon color="error" />}
        onClick={() => handleOpenDialog()}
      />
      <Dialog open={openDialog} onClose={handleOnClose ? handleOnClose : handleCloseDialog}>
        <DialogTitle>{t('actions.confirmation.delete')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message ? message : ''}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOnClose ? handleOnClose : handleCloseDialog} color="primary">
            {t('actions.cancel')}
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            {t('actions.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
